import { RouteObject } from 'react-router-dom'
import { LoadedPageContent } from '../../common/app'
import { default as Stock } from '.'

const basePath = '/stock'
export const stockRoutes: RouteObject[] = [
  {
    path: `${basePath}/invoices`,
    element: (
      <LoadedPageContent title="Incoming Invoices" displayLeftTitle={false}>
        <Stock.Invoices.Component />
      </LoadedPageContent>
    ),
    loader: Stock.Invoices.Loader,
  },
  {
    path: '/stock/invoices/history',
    element: (
      <LoadedPageContent title="Invoice History" displayLeftTitle={false}>
        <Stock.InvoiceHistory.Component />
      </LoadedPageContent>
    ),
    loader: Stock.Invoices.Loader,
  },
  {
    path: `${basePath}/invoices/:invoiceId`,
    element: (
      <LoadedPageContent title="Receive Invoice" displayLeftTitle={false}>
        <Stock.EditInvoice.Component />
      </LoadedPageContent>
    ),
    loader: Stock.EditInvoice.Loader,
  },
]
